import React from 'react';

const FooterDetails = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2 className="footer-title">STARLINK VPN</h2>
        <p className="footer-copy">&copy; 2024 FixBuild. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default FooterDetails;
